// src/utils/precision.js
const factorMap = {
    seconds:   1,
    '1/5':     5,
    '1/10':    10,
    '1/100':   100,
    '1/1000':  1000,
    '1/10000': 10000,
  };
  const decimalsMap = {
    seconds:   0,
    '1/5':     1,
    '1/10':    1,
    '1/100':   2,
    '1/1000':  3,
    '1/10000': 4,
  };
  
  export function formatWithPrecision(seconds, precision) {
    const factor   = factorMap[precision]    ?? factorMap['1/100'];
    const decimals = decimalsMap[precision] ?? decimalsMap['1/100'];
    // 1) redondeo
    const rounded = Math.round(seconds * factor) / factor;
  
    // 2) descomponer h/m/s
    const hrs   = Math.floor(rounded / 3600);
    const rem   = rounded % 3600;
    const mins  = Math.floor(rem / 60);
    const secs  = rem % 60;
  
    // 3) formato de segundos con ceros y decimales
    const secsStr = secs
      .toFixed(decimals)                       // usa el decimal fijo
      .padStart(decimals > 0 ? 3 + decimals : 2, '0');
  
    // 4) montar cadena
    if (hrs > 0) {
      return `${hrs}:${String(mins).padStart(2, '0')}:${secsStr}`;
    }
    if (mins > 0) {
      return `${String(mins).padStart(2,'0')}:${secsStr}`;
    }
    return secsStr;
  }
  